export class User {
    email!: string;
    password?: string;

    name!: string;

    firstname!: string;
    middlename?: string;
    lastname!: string;

    customer_no!: string;
    'customer-name'?: string;

    gender: 'male' | 'female' | 'other' = 'male';
    
    date_of_birth!: BirthDate;

    dob!: BirthDate;
}

export class BirthDate {
    date!: number;
    month!: number;
    year!: number;
}
